import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import taskPartnerSearch from 'features/views/taskPartnerSearch';

import PartnerTableRow from './PartnerTableRow';

export const PszpNoticeTable = ({ taskId }) => {
	const partners = useSelector(taskPartnerSearch.selectors.getTaskPartners);

	const hasRecords = !isEmpty(partners);
	return (
		hasRecords && (
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>{getLabelMessage('pszpNotice:nameSurname')}</TableCell>
						<TableCell>{getLabelMessage('pszpNotice:birthNumber')}</TableCell>
						<TableCell>{getLabelMessage('pszpNotice:address')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{partners &&
						partners.map((partner) => (
							<TableRow key={partner.id}>
								<PartnerTableRow key={partner.id} taskId={taskId} partner={partner} />
							</TableRow>
						))}
				</TableBody>
			</Table>
		)
	);
};

PszpNoticeTable.propTypes = {
	taskId: PropTypes.number,
};

export default PszpNoticeTable;
